"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PtoRequestEdit;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_2 = require("react-native");
const cancelable_promise_1 = require("cancelable-promise");
const ModalWrapper_1 = __importDefault(require("../components/ModalWrapper"));
const Button_1 = __importDefault(require("../components/Button"));
const Loading_1 = __importDefault(require("../components/Loading"));
const Helper_1 = require("../Helper");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const UserContext_1 = require("../contexts/UserContext");
const TimeAttendance_1 = __importDefault(require("../api/TimeAttendance"));
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const react_native_paper_dates_1 = require("react-native-paper-dates");
const react_native_paper_1 = require("react-native-paper");
const SearchableDropdown_1 = __importDefault(require("../components/SearchableDropdown"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
function EditPtoRangeForm({ item, isChanged, isSubmitting, onCancel, onSave, onIsChanged, t }) {
    const THEME = (0, ThemeContext_1.useTheme)();
    const initDone = react_1.default.useRef(false);
    const [rangePicker, setRangePicker] = react_1.default.useState(false);
    const [startDate, setStartDate] = react_1.default.useState(null);
    const [endDate, setEndDate] = react_1.default.useState(null);
    const [includeWeekends, setIncludeWeekends] = react_1.default.useState(false);
    const [requestDates, setRequestDates] = react_1.default.useState([]);
    const [hoursPerDay, setHoursPerDay] = react_1.default.useState('');
    const [hoursMsg, setHoursMsg] = react_1.default.useState(null);
    const [comment, setComment] = react_1.default.useState('');
    const deviceLang = Helper_1.Helper.deviceLanguage();
    const datePickerLocale = deviceLang === 'en-US' ? 'en' : deviceLang === 'es-US' ? 'es' : deviceLang;
    const addDaysUtc = (d, n = 1) => new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + n));
    const formatDate = (d) => d.toLocaleDateString(deviceLang, { month: 'short', day: 'numeric', year: d.getUTCFullYear() !== new Date().getFullYear() ? 'numeric' : undefined, timeZone: 'UTC' });
    const buildDateStr = (d) => {
        const y = d.getUTCFullYear();
        const m = String(d.getUTCMonth() + 1).padStart(2, '0');
        const day = String(d.getUTCDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
    };
    const computeDates = (startDate, endDate, includeWeekends) => {
        const dates = [];
        if (startDate && endDate) {
            let cur = new Date(Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate()));
            const end = new Date(Date.UTC(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate()));
            while (cur.getTime() <= end.getTime()) {
                const dow = cur.getUTCDay(); // 0 dom, 6 sáb
                if (includeWeekends || (dow !== 0 && dow !== 6))
                    dates.push(new Date(cur));
                cur = new Date(Date.UTC(cur.getUTCFullYear(), cur.getUTCMonth(), cur.getUTCDate() + 1));
            }
        }
        return dates;
    };
    const booleanOptions = [
        {
            label: t('common:text.yes'),
            value: "true",
        },
        {
            label: t('common:text.no'),
            value: "false",
        },
    ];
    react_1.default.useEffect(() => {
        if (!item?.ptoDays?.length)
            return;
        if (isChanged || initDone.current)
            return;
        const dates = [...item.ptoDays]
            .map(d => new Date(`${d.requestDate}T00:00:00Z`))
            .sort((a, b) => a.getTime() - b.getTime());
        const s = dates[0];
        const e = dates[dates.length - 1];
        setStartDate(s);
        setEndDate(e);
        const hasWeekend = dates.some(d => d.getUTCDay() === 0 || d.getUTCDay() === 6);
        setIncludeWeekends(hasWeekend);
        const firstHours = item.ptoDays[0]?.hours ?? '';
        const uniform = item.ptoDays.every(d => d.hours === firstHours);
        setHoursPerDay(uniform ? firstHours : '');
        setComment(item.comment ?? '');
        const calc = (S, E, inc) => {
            const arr = [];
            let cur = new Date(Date.UTC(S.getUTCFullYear(), S.getUTCMonth(), S.getUTCDate()));
            const end = new Date(Date.UTC(E.getUTCFullYear(), E.getUTCMonth(), E.getUTCDate()));
            while (cur.getTime() <= end.getTime()) {
                const dow = cur.getUTCDay();
                if (dow !== 0 && dow !== 6 || inc)
                    arr.push(new Date(cur));
                cur = addDaysUtc(cur, 1);
            }
            return arr;
        };
        initDone.current = true;
        setRequestDates(calc(s, e, hasWeekend));
    }, [item?.requestId, isChanged]);
    const recalc = react_1.default.useCallback((S, E) => {
        const arr = [];
        if (S && E) {
            let cur = new Date(Date.UTC(S.getUTCFullYear(), S.getUTCMonth(), S.getUTCDate()));
            const end = new Date(Date.UTC(E.getUTCFullYear(), E.getUTCMonth(), E.getUTCDate()));
            while (cur.getTime() <= end.getTime()) {
                const dow = cur.getUTCDay();
                if (dow !== 0 && dow !== 6)
                    arr.push(new Date(cur));
                else if (includeWeekends)
                    arr.push(new Date(cur));
                cur = addDaysUtc(cur);
            }
        }
        setRequestDates(arr);
    }, [includeWeekends]);
    const utcToLocalDateOnly = (d) => d ? new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()) : null;
    const hoursInvalid = react_1.default.useMemo(() => {
        if (hoursPerDay === '' || hoursPerDay == null)
            return true;
        const n = Number(hoursPerDay);
        return !isFinite(n) || n <= 0 || n >= 24;
    }, [hoursPerDay]);
    const canSave = !!startDate && !!endDate && requestDates.length > 0 && !hoursInvalid;
    const todayUtcMidnight = react_1.default.useMemo(() => {
        const now = new Date();
        return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    }, []);
    const localFromUtcDateOnly = (d) => new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_paper_dates_1.DatePickerModal, { startLabel: t('common:text.start'), endLabel: t('common:text.end'), locale: datePickerLocale, mode: "range", visible: rangePicker, onDismiss: () => { setRangePicker(false); if (!startDate && !endDate)
                    onCancel(); }, startDate: utcToLocalDateOnly(startDate), endDate: utcToLocalDateOnly(endDate), validRange: { startDate: localFromUtcDateOnly(todayUtcMidnight) }, saveLabel: t('common:buttons.confirm'), uppercase: false, inputEnabled: false, onConfirm: ({ startDate: s, endDate: e }) => {
                    const sLocal = s ?? e;
                    const eLocal = e ?? s;
                    let S = new Date(Date.UTC(sLocal.getFullYear(), sLocal.getMonth(), sLocal.getDate()));
                    let E = new Date(Date.UTC(eLocal.getFullYear(), eLocal.getMonth(), eLocal.getDate()));
                    if (S.getTime() < todayUtcMidnight.getTime())
                        S = new Date(todayUtcMidnight);
                    if (E.getTime() < todayUtcMidnight.getTime())
                        E = new Date(todayUtcMidnight);
                    setStartDate(S);
                    setEndDate(E);
                    recalc(S, E);
                    setRangePicker(false);
                    onIsChanged();
                } }), startDate && endDate && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TouchableRipple, { onPress: () => setRangePicker(true), "aria-label": t('time:buttons.adjustDates'), style: { marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { pointerEvents: 'none' }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { accessible: false, readOnly: true, value: `${formatDate(startDate)} — ${formatDate(endDate)}`, mode: "outlined", label: t('time:buttons.adjustDates'), right: 
                                // @ts-ignore
                                (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput.Icon, { icon: () => (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.Calendar, color: THEME.Text }), onPress: () => setRangePicker(true), forceTextInputFocus: false }) }) }) }), (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('time:labels.hoursPerDay'), dense: true, error: !!hoursMsg || hoursInvalid, label: `${t('time:labels.hoursPerDay')} *`, mode: "outlined", inputMode: "decimal", value: hoursPerDay ?? '', onChangeText: (v) => {
                            const trimmed = (v ?? '').trim();
                            if (trimmed === '') {
                                setHoursMsg(t('time:messages.noHoursError'));
                            }
                            else {
                                const n = Number(trimmed);
                                if (!isFinite(n) || n <= 0)
                                    setHoursMsg(t('time:messages.noHoursError'));
                                else if (n >= 24)
                                    setHoursMsg(t('time:messages.maxHoursError'));
                                else
                                    setHoursMsg(null);
                            }
                            setHoursPerDay(v);
                            onIsChanged();
                        }, onBlur: () => {
                            if (!hoursPerDay || hoursPerDay.trim() === '') {
                                setHoursMsg(t('time:messages.noHoursError'));
                            }
                        } }), !!hoursMsg && (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { type: "error", visible: true, children: hoursMsg }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('time:labels.ptoComment'), dense: true, label: t('time:labels.ptoComment'), mode: "outlined", value: comment, onChangeText: (v) => { setComment(v); onIsChanged(); } }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: booleanOptions, label: t('time:labels.includeWeekends'), mode: "outlined", setValue: (val) => {
                                const next = val === "true";
                                setIncludeWeekends(next);
                                if (startDate && endDate) {
                                    setRequestDates(computeDates(startDate, endDate, next));
                                }
                                onIsChanged();
                            }, value: includeWeekends ? "true" : "false" }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 18, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "outline", text: t('common:buttons.cancel'), onPress: onCancel, disabled: isSubmitting }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { text: t('common:buttons.save'), type: "solid", disabled: isSubmitting || !canSave, onPress: () => {
                                        const datesPayload = requestDates.map(d => ({ requestDate: buildDateStr(d), hours: hoursPerDay }));
                                        onSave(datesPayload, comment ?? '');
                                    } }) })] })] }))] }));
}
function PtoRequestEdit(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const saveLock = react_1.default.useRef(false);
    const requestId = props?.route?.params?.requestId;
    const [status, setStatus] = react_1.default.useState('loading');
    const [editItem, setEditItem] = react_1.default.useState(null);
    const [isChanged, setIsChanged] = react_1.default.useState(false);
    const [isConfirming, setIsConfirming] = react_1.default.useState(false);
    const [allRequests, setAllRequests] = react_1.default.useState([]);
    const [isSubmitting, setIsSubmitting] = react_1.default.useState(false);
    const onClose = () => {
        if (isChanged) {
            setIsConfirming(true);
        }
        else {
            props.navigation.goBack();
        }
    };
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        const getToken = userContext.getToken;
        promise.current = (0, cancelable_promise_1.cancelable)(getToken().then((token) => TimeAttendance_1.default.getEmployeePtoRequests(token, null, null)).catch((e) => {
            throw e;
        })).then((data) => {
            const list = Array.isArray(data) ? data : [];
            setAllRequests(list);
            const found = list.find((r) => r.requestId === requestId) ?? null;
            setEditItem(found);
            setStatus('done');
        })
            .catch(() => {
            setEditItem(null);
            setStatus('error');
        });
    }, [requestId]);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, [refresh]);
    react_1.default.useEffect(() => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            feature: 'Edit PTO Request',
            client: userContext.client?.id,
            employee: userContext.employee?.employeeId,
        });
    }, []);
    if (!requestId) {
        return ((0, jsx_runtime_1.jsx)(ModalWrapper_1.default, { navigation: props.navigation, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { padding: 16 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.Text, { children: [t('common:error'), ": missing requestId"] }) }) }));
    }
    return ((0, jsx_runtime_1.jsxs)(ModalWrapper_1.default, { navigation: props.navigation, needsConfirmation: isChanged, onConfirmation: () => setIsConfirming(true), children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingHorizontal: 12, paddingTop: 8, paddingBottom: 2 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Pen, size: 20, color: THEME.Secondary }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontWeight: '500', fontSize: size != 'sm' ? 18 : 16, marginLeft: 12 }, children: t('time:headers.editPtoRequest') }), !!editItem?.registerDescription && ((0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, marginLeft: 12 }, children: editItem.registerDescription }))] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('common:buttons.close'), hitSlop: 12, type: "borderless", onPress: onClose, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) })] }) }), (0, jsx_runtime_1.jsxs)(react_native_1.ScrollView, { contentContainerStyle: { paddingHorizontal: 12, paddingBottom: 12 }, keyboardShouldPersistTaps: "handled", children: [isConfirming && ((0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                    marginBottom: 12,
                                    backgroundColor: THEME.UltraLightGray,
                                    borderRadius: 4,
                                    flexDirection: 'row',
                                }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 6, borderBottomLeftRadius: 4, borderTopLeftRadius: 4, backgroundColor: THEME.Red } }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { padding: 12, flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                    color: THEME.Text,
                                                    fontSize: size != 'sm' ? 14 : 12,
                                                    fontWeight: '500',
                                                    paddingVertical: 1,
                                                }, children: t('common:text.sure') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, paddingVertical: 1 }, children: t('common:text.sureDescription') })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 6, marginBottom: size != 'sm' ? 0 : 12, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "outline", text: t('common:buttons.back'), onPress: () => setIsConfirming(false) }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { text: t('common:buttons.discard'), onPress: () => props.navigation.goBack() }) })] })] })), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { display: isConfirming ? 'none' : undefined }, children: userContext.isImpersonated ? ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { padding: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.TextNull }, children: t('common:messages.impersonatedUser') }) })) : status === 'done' && editItem ? ((0, jsx_runtime_1.jsx)(EditPtoRangeForm, { item: editItem, t: t, isChanged: isChanged, isSubmitting: isSubmitting, onIsChanged: () => setIsChanged(true), onCancel: onClose, onSave: async (dates, comment) => {
                                if (saveLock.current)
                                    return;
                                saveLock.current = true;
                                try {
                                    setIsSubmitting(true);
                                    const body = { requestId, dates };
                                    if (editItem?.accountId)
                                        body.accountId = editItem.accountId;
                                    const originalComment = editItem?.comment ?? '';
                                    if ((comment ?? '') !== originalComment)
                                        body.comment = comment ?? '';
                                    const token = await userContext.getToken();
                                    const resp = await TimeAttendance_1.default.editPtoRequest(token, body);
                                    await refresh();
                                    react_native_2.DeviceEventEmitter.emit('event.ptoRequestUpdate');
                                    if (resp?.success) {
                                        react_native_2.DeviceEventEmitter.emit('event.showSnackbar', {
                                            type: 'success',
                                            message: t('time:messages.ptoRequestEditSuccess'),
                                        });
                                        props.navigation.goBack();
                                        return;
                                    }
                                }
                                catch {
                                    react_native_2.DeviceEventEmitter.emit('event.showSnackbar', {
                                        type: 'error',
                                        message: t('time:messages.ptoRequestEditError'),
                                    });
                                }
                                finally {
                                    setIsSubmitting(false);
                                    saveLock.current = false;
                                }
                            } })) : ((0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status === 'loading', error: status === 'error' || (status === 'done' && !editItem), onRetry: () => refresh() })) })] })] }));
}
